module.exports = __webpack_public_path__ + "img/Medidas2.3d088b82.png";